var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5687)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9833_5687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9833_5687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5687)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9833_5687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 9,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H5V12H14V6Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9833_5687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60937 6H13.3906C13.5522 6.00036 13.7069 6.05808 13.8211 6.16059C13.9353 6.2631 13.9996 6.40203 14 6.54702V11.453C13.9995 11.5979 13.935 11.7367 13.8209 11.8392C13.7067 11.9416 13.5521 11.9995 13.3906 12H5.60937C5.44794 11.9995 5.29329 11.9416 5.17914 11.8392C5.06495 11.7367 5.00056 11.5979 5 11.453V6.54702C5.00038 6.40203 5.06473 6.2631 5.17891 6.16059C5.2931 6.05808 5.44786 6.00036 5.60937 6ZM11.5039 9.57921C11.5143 9.53913 11.542 9.50436 11.581 9.48261C11.6199 9.46083 11.6668 9.45384 11.7116 9.46317C11.7562 9.4725 11.795 9.4974 11.8192 9.53235C11.8434 9.5673 11.8512 9.60948 11.8408 9.64956L11.4659 11.0914C11.4554 11.1315 11.4277 11.1662 11.3887 11.1881C11.3499 11.2098 11.3029 11.2168 11.2581 11.2074C11.2135 11.1981 11.1748 11.1732 11.1505 11.1382C11.1263 11.1033 11.1185 11.0612 11.1289 11.021L11.5039 9.57921ZM6.18508 10.814C6.1334 10.814 6.08383 10.7955 6.0473 10.7627C6.01077 10.7299 5.99022 10.6854 5.99022 10.6391C5.99022 10.5927 6.01077 10.5482 6.0473 10.5154C6.08383 10.4826 6.1334 10.4641 6.18508 10.4641H8.01612C8.0417 10.4641 8.06705 10.4687 8.09067 10.4775C8.1143 10.4863 8.13579 10.4992 8.15386 10.5154C8.17198 10.5317 8.1863 10.5509 8.19613 10.5721C8.20592 10.5934 8.21094 10.6161 8.21094 10.6391C8.21094 10.662 8.20592 10.6848 8.19613 10.706C8.1863 10.7272 8.17198 10.7464 8.15386 10.7627C8.13579 10.7789 8.1143 10.7918 8.09067 10.8006C8.06705 10.8094 8.0417 10.814 8.01612 10.814H6.18508ZM6.18508 9.72189C6.1334 9.72189 6.08383 9.70347 6.0473 9.67068C6.01077 9.63786 5.99022 9.5934 5.99022 9.54702C5.99022 9.50064 6.01077 9.45615 6.0473 9.42336C6.08383 9.39054 6.1334 9.37212 6.18508 9.37212H9.36669C9.41836 9.37212 9.46793 9.39054 9.5045 9.42336C9.54095 9.45615 9.56156 9.50064 9.56156 9.54702C9.56156 9.5934 9.54095 9.63786 9.5045 9.67068C9.46793 9.70347 9.41836 9.72189 9.36669 9.72189H6.18508ZM6.18508 8.62986C6.1334 8.62986 6.08383 8.61141 6.0473 8.57862C6.01077 8.54583 5.99022 8.50134 5.99022 8.45496C5.99022 8.40858 6.01077 8.36409 6.0473 8.3313C6.08383 8.29851 6.1334 8.28009 6.18508 8.28009H11.2256C11.2773 8.28009 11.3268 8.29851 11.3634 8.3313C11.3999 8.36409 11.4204 8.40858 11.4204 8.45496C11.4204 8.50134 11.3999 8.54583 11.3634 8.57862C11.3268 8.61141 11.2773 8.62986 11.2256 8.62986H6.18508ZM10.9165 10.7337C10.9482 10.7614 10.9668 10.7989 10.9686 10.8386C10.9703 10.8783 10.9552 10.917 10.9261 10.9469C10.897 10.9768 10.8563 10.9956 10.8122 10.9994C10.7683 11.0031 10.7243 10.9915 10.6894 10.9671L10.0303 10.451C10.0133 10.4377 9.99932 10.4214 9.98924 10.4032C9.97925 10.385 9.97331 10.3651 9.97178 10.3449C9.97025 10.3246 9.97322 10.3042 9.98051 10.285C9.9878 10.2658 9.99923 10.248 10.0142 10.2327C10.0192 10.2272 10.0249 10.2222 10.031 10.2176L10.6902 9.70218C10.7245 9.67515 10.7694 9.66147 10.8151 9.6642C10.8607 9.6669 10.9033 9.68577 10.9333 9.71664C10.9635 9.74751 10.9787 9.7878 10.9756 9.82875C10.9727 9.8697 10.9516 9.90788 10.9172 9.93495L10.4096 10.3346L10.9165 10.7337ZM12.3242 10.9678C12.3071 10.9812 12.2872 10.9914 12.2657 10.9979C12.2442 11.0044 12.2214 11.007 12.1988 11.0056C12.1761 11.0041 12.154 10.9987 12.1337 10.9897C12.1133 10.9806 12.0952 10.968 12.0803 10.9527C12.0654 10.9372 12.054 10.9194 12.0468 10.9001C12.0395 10.8808 12.0366 10.8604 12.0383 10.84C12.0398 10.8197 12.0458 10.7998 12.0559 10.7816C12.066 10.7634 12.08 10.7471 12.0971 10.7337L12.6047 10.3346L12.0971 9.93555C12.0801 9.9222 12.0663 9.90593 12.0562 9.8877C12.0462 9.86948 12.0402 9.84967 12.0387 9.82942C12.0373 9.80917 12.0402 9.78885 12.0474 9.76958C12.0547 9.7503 12.0662 9.73257 12.081 9.7173C12.096 9.702 12.114 9.68952 12.1344 9.68052C12.1546 9.67152 12.1767 9.66621 12.1993 9.66486C12.2219 9.66351 12.2446 9.66618 12.266 9.67269C12.2874 9.6792 12.3072 9.68943 12.3242 9.70284L12.9834 10.2183C12.9896 10.2228 12.9951 10.2279 13.0003 10.2334C13.0151 10.2487 13.0267 10.2665 13.0339 10.2857C13.0411 10.3049 13.0441 10.3252 13.0426 10.3455C13.0411 10.3658 13.0352 10.3856 13.0251 10.4039C13.0151 10.4221 13.0012 10.4384 12.9841 10.4517L12.3242 10.9678ZM13.6426 7.53123H5.38745V11.5063C5.3876 11.5263 5.39228 11.5462 5.40121 11.5646C5.41017 11.583 5.42315 11.5997 5.43946 11.6135C5.4551 11.6275 5.4737 11.6387 5.49421 11.6462C5.51473 11.6538 5.53666 11.6576 5.55883 11.6575H13.469C13.4911 11.6576 13.5131 11.6538 13.5336 11.6462C13.5541 11.6387 13.5728 11.6275 13.5883 11.6135C13.6042 11.5994 13.6166 11.5827 13.6251 11.5643C13.6334 11.5459 13.6377 11.5261 13.6375 11.5063V7.53123H13.6426ZM12.8106 6.61473C12.8701 6.61461 12.9284 6.63033 12.978 6.65994C13.0275 6.68955 13.0662 6.73173 13.0892 6.78108C13.1121 6.83043 13.1182 6.88479 13.1066 6.93726C13.0951 6.98973 13.0664 7.03794 13.0244 7.07577C12.9823 7.11363 12.9287 7.13943 12.8702 7.14993C12.8118 7.1604 12.7512 7.15509 12.6963 7.13466C12.6412 7.11423 12.5942 7.07958 12.5611 7.03515C12.528 6.99069 12.5102 6.93843 12.5102 6.88494C12.5102 6.81339 12.5418 6.74475 12.5982 6.69411C12.6545 6.64344 12.7308 6.61491 12.8106 6.61473ZM10.7714 6.61473C10.831 6.61473 10.8892 6.63057 10.9387 6.66027C10.9882 6.68997 11.0268 6.73215 11.0496 6.78153C11.0724 6.83091 11.0783 6.88524 11.0667 6.93765C11.0551 6.99009 11.0264 7.03824 10.9844 7.07601C10.9422 7.11381 10.8886 7.13955 10.8302 7.14996C10.7718 7.1604 10.7113 7.15503 10.6563 7.1346C10.6013 7.11414 10.5543 7.07952 10.5212 7.03506C10.4881 6.99063 10.4705 6.9384 10.4705 6.88494C10.4705 6.81327 10.5021 6.74454 10.5586 6.69387C10.6151 6.6432 10.6916 6.61473 10.7714 6.61473ZM11.791 6.61473C11.8505 6.61473 11.9088 6.63057 11.9583 6.66027C12.0078 6.68997 12.0463 6.73215 12.0691 6.78153C12.0919 6.83091 12.0978 6.88524 12.0862 6.93765C12.0746 6.99009 12.046 7.03824 12.0039 7.07601C11.9618 7.11381 11.9081 7.13955 11.8497 7.14996C11.7914 7.1604 11.7308 7.15503 11.6758 7.1346C11.6208 7.11414 11.5738 7.07952 11.5407 7.03506C11.5076 6.99063 11.49 6.9384 11.49 6.88494C11.49 6.81327 11.5217 6.74454 11.5782 6.69387C11.6346 6.6432 11.7112 6.61473 11.791 6.61473Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5687",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5687",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptShort);
export default __webpack_public_path__ + "static/media/Script-Short.0f9826b6025dd45330d4e71c069a17f8.svg";
export { ForwardRef as ReactComponent };